/** Human-readable fee bearer for staff UI (matches API lowercase values). */
export function formatFeeBearer(bearer) {
  if (bearer == null || bearer === "") return "—";
  const s = String(bearer).toLowerCase();
  if (s === "member") return "Member";
  if (s === "organization" || s === "organisation") return "Cooperative (organization)";
  return String(bearer);
}

export function formatPaymentCategory(cat) {
  if (!cat) return "—";
  const map = {
    contribution: "Contribution",
    loan_repayment: "Loan repayment",
    attendance_fine: "Attendance fine",
    registration: "Registration",
    other: "Other",
  };
  return map[cat] || String(cat);
}
